import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';

// ─── Notification inbox (Round 21) — sidebar bell icon + dropdown ──────────
export function NotificationBell({ currentUser, onOpenLink }) {
  const headers = { 'x-user-id': String(currentUser.id) };
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  async function load() {
    try {
      const r = await api('GET', '/api/notifications', null, headers);
      setItems(r.notifications || []);
      setUnread(r.unreadCount || 0);
    } catch {}
  }
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  async function markRead(id) {
    // Optimistic: REMOVE the row from the panel — CJ wants cleared
    // notifications to disappear, not stick around in a faded state.
    // Badge drops + row goes away the instant the user taps.
    const wasUnread = !items.find(n => n.id === id)?.read_at;
    if (wasUnread) setUnread(u => Math.max(0, u - 1));
    setItems(rows => rows.filter(n => n.id !== id));
    try { await api('PUT', `/api/notifications/${id}/read`, {}, headers); } catch {}
  }
  async function markAll() {
    // Clear everything from the panel + close it. Same reasoning — if
    // you've cleared them, you don't want them lingering visually.
    setUnread(0);
    setItems([]);
    setOpen(false);
    try { await api('PUT', '/api/notifications/read-all', {}, headers); } catch {}
  }

  return (
    <div style={{ position: 'relative' }}>
      <button onClick={() => setOpen((s) => !s)} title="Notifications"
        style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: 6,
                  position: 'relative', fontSize: 18, color: '#37474f' }}>
        🔔
        {unread > 0 && (
          <span style={{ position: 'absolute', top: 0, right: 0,
                          background: '#c62828', color: '#fff', fontSize: 9, fontWeight: 700,
                          borderRadius: 999, padding: '1px 5px', minWidth: 16 }}>
            {unread > 9 ? '9+' : unread}
          </span>
        )}
      </button>
      {open && (
        <div style={{ position: 'absolute', right: 0, top: '110%', width: 360, maxHeight: 400,
                        overflow: 'auto', background: '#fff', border: '1px solid #d0d4d9',
                        borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 100 }}>
          <div style={{ padding: '8px 12px', display: 'flex', justifyContent: 'space-between',
                          alignItems: 'center', borderBottom: '1px solid #f0f0f0' }}>
            <div style={{ fontSize: 13, fontWeight: 700 }}>Notifications</div>
            {unread > 0 && (
              <button onClick={markAll}
                style={{ fontSize: 11, color: '#1565c0', background: 'transparent', border: 'none', cursor: 'pointer' }}>
                Mark all read
              </button>
            )}
          </div>
          {items.length === 0 && (
            <div style={{ padding: 16, fontSize: 12, color: '#9e9e9e', textAlign: 'center' }}>
              No notifications yet.
            </div>
          )}
          {items.map((n) => (
            <div key={n.id}
              onClick={() => { markRead(n.id); if (n.link_tab && onOpenLink) onOpenLink(n.link_tab); setOpen(false); }}
              style={{ padding: '8px 12px', borderBottom: '1px solid #f5f5f5',
                        background: n.read_at ? '#fff' : '#fffde7',
                        cursor: 'pointer' }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#212121' }}>{n.title}</div>
              {n.body && <div style={{ fontSize: 11, color: '#37474f', marginTop: 2 }}>{n.body}</div>}
              <div style={{ fontSize: 10, color: '#9e9e9e', marginTop: 3 }}>{n.created_at?.slice(0, 16)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
